export default __webpack_public_path__ + "static/media/showerRain.9b934732.svg";